export default __webpack_public_path__ + "static/media/person_1.a89ca422.png";